import styles from './conflict-check-diary-dialog.module.scss';
import { useTranslation } from 'react-i18next';
import { Dialog, DialogActions, DialogContent, DialogTitle, PrimaryButton } from '@frontend-workspace/react-shared-lib';

/* eslint-disable-next-line */
export interface ConflictCheckDiaryDialogProps {
  onClose: () => void,
  open: boolean,
  conflicts: string
}

export function ConflictCheckDiaryDialog(props: ConflictCheckDiaryDialogProps) {
  const { t } = useTranslation();

  return (
    <Dialog
      open={props.open}
      onClose={props.onClose}
      maxWidth="xl">
      <DialogTitle className='mb-4'>
        {t("standard.conflicts")}
      </DialogTitle>
      <DialogContent>
        <pre>{props.conflicts}</pre>
      </DialogContent>
      <DialogActions>
        <PrimaryButton
          variant="contained"
          size='large'
          onClick={props.onClose}
          className='minButtonWidth'>
          OK
        </PrimaryButton>
      </DialogActions>
    </Dialog>
  );
}

export default ConflictCheckDiaryDialog;
